import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import styles from "../../assets/scss/Settings/Settings.module.scss";
import { BaseURL } from "../../lib/api";
import { getUserInfo } from "../../utils/user.util";
import { useGetUserByIdQuery } from "../../slices/admin/admin";

const RS232Settings = () => {
    const localUser = getUserInfo();
    const userId = localUser?._id;
    const navigate = useNavigate();

    const { data: apiData, refetch } = useGetUserByIdQuery(userId, { skip: !userId });

    const [showRS232, setShowRS232] = useState(localUser?.isRS232Enabled ?? false);

    useEffect(() => {
        if (apiData?.result?.length > 0) {
            const user = apiData.result[0];
            setShowRS232(user.isRS232Enabled ?? false);
        }
    }, [apiData]);

    const handleSave = async () => {
        try {
            const formData = new FormData();
            formData.append("isRS232Enabled", showRS232);

            const rawToken = localStorage.getItem("token");
            const token = rawToken?.replace(/^"|"$/g, "");

            const response = await axios.put(`${BaseURL}/user/update/settings`, formData, {
                headers: {
                    authorization: token,
                    "Content-Type": "multipart/form-data",
                },
            });

            toast.success(response.data.message || "RS-232 Settings updated successfully!");
            refetch();
        } catch (err) {
            console.error(err);
            toast.error("Failed to update RS-232 settings");
        }
    };

    return (
        <div className={styles.settingsContainer}>
            <div className={styles.headerRow}>
                <h2 className={styles.header}>RS-232 Weight Machine Setting</h2>
            </div>

            <div className={styles.card}>
                <div className={styles.toggleLogoBoxRs}>
                    <span className={styles.toggleText}>
                        {showRS232
                            ? "RS-232 Weight Machine Setting Shown"
                            : "RS-232 Weight Machine Setting Hidden"}
                    </span>
                    <div
                        className={`${styles.toggleSwitch} ${showRS232 ? styles.on : styles.off}`}
                        onClick={() => setShowRS232(!showRS232)}
                    >
                        <div className={styles.toggleCircle}></div>
                    </div>
                </div>

                {showRS232 && (
                    <div className={styles.instructionsBox}>
                        <h3 className={styles.instructionsHeader}>Setup Instructions</h3>
                        <ol className={styles.instructionsList}>
                            <li>
                                Connect the device to your system using the appropriate cable or adapter.
                            </li>
                            <li>
                                Install the compatible driver for the connected device or adapter before use.
                            </li>
                            <li>
                                Once installed, confirm that the device appears correctly in your system’s device list or ports.
                            </li>
                            <li>
                                Use the detected device path or port in your application to communicate or read data.
                            </li>
                        </ol>
                    </div>
                )}

                <div className={styles.footerButtons}>
                    <button className={styles.cancel} onClick={() => navigate('/dashboard')}>Cancel</button>
                    <button className={styles.save} onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default RS232Settings;
